var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"src":require("./img2.png"),"alt":""}}),_c('div',{staticClass:"clickBlock area1",on:{"click":_vm.area1Fun}}),_c('div',{staticClass:"clickBlock area2",on:{"click":_vm.area2Fun}})])
}
var staticRenderFns = []

export { render, staticRenderFns }